module.exports = __webpack_public_path__ + "static/media/40_A.43aa73c6.png";